import {HeaderCell} from './components'
import {Layout} from '../../../layout'
import './styles/index.less'

export * from './helpers'

export const AdvancedTableHeader = ({headers = [], ...rest}) => {
	'use no memo'
	return (
		<Layout className="advanced-table-header" width="100%" gap={0}>
			{headers.map(h => (
				<HeaderCell header={h} {...rest} />
			))}
		</Layout>
	)
}
